import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { QUERY_BLACKLIST as BLACKLIST } from '../../constants';
import { Chip } from './chip';

const Chips = ({ query, handleClick }) => {
  const [chips, setChips] = React.useState([])
  const systemState = useSelector(state => state.system)
  const {
    converterTerms,
    language
  } = systemState

  const convertToChips = (query = {}) => {
    // Override 'audience' to 'typeAudience' manually
    const cloned = {...query}
    if(query.audience){
      cloned.typeAudience = query.audience
      delete cloned.audience
    }

    // Start converting
    let result = []

    function pushToResult(id, key){
      const listingById = converterTerms.queryToStateKey[key] // e.g. approachesById
      const data = systemState[listingById]?.[id]

      if(data){
        const newData = {
          ...data,
          label: data.name[language.name],
          key
        }
        result.push(newData)
      }
    }

    if(Object.keys(cloned).length > 0){
      for(let key in cloned){
        const value = cloned[key]

        const allowDirectPush = key === 'keyword'
          || key === 'provinsi'
          || key === 'city'
          || key === 'startRentangWaktu'
          || key === 'endRentangWaktu'

        if(value && BLACKLIST.includes(key) === false){
          if(allowDirectPush){
            result.push({
              key,
              label: value,
              value
            })
          } else {
            // Single value
            if(typeof value === 'string'){
              const id = value
              pushToResult(id, key)
            }
            // Array value
            else if(typeof value === 'object' && value.length > 0) {
              for (let index = 0; index < value.length; index++) {
                const id = value[index];
                pushToResult(id, key)
              }
            }
          }
        }
      }
    }

    setChips(result)
  }

  useEffect(() => {
    if (query) convertToChips(query)
    // eslint-disable-next-line
  }, [query])

  return <>
    {/* Don't add 'flex-wrap'. It should be x-axis overflowed */}
    <div className="pl-8 md:pl-0 flex">
      {
        chips.map(chip => (
          <Chip
            className="mr-2 mb-2"
            key={chip.label}
            onClick={() => handleClick(chip)}
          >
            {chip.label}
          </Chip>
        ))
      }
    </div>
  </>
}

export default Chips
